import { NumericValue } from '../math/Decimal';
import { formatNumericValue } from './numberFormatter';

export const formatPercentage = (value: NumericValue): string => `${formatNumericValue(value)} %`;
